
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import CButton from '../CButton/CButton'
import NP from 'number-precision'

const winPrizeTipTime = 3 * 1000
export default {
name: 'confirm',
components: {
XDialog, XButton, Flexbox, FlexboxItem, CButton
},
props: {
value: {
type: Boolean,
default: false
},
placeholder: {
type: String,
default: ''
},
theme: {
type: String,
default: 'ios'
},
hideOnBlur: {
type: Boolean,
default: false
},
title: String,
confirmText: String,
cancelText: String,
maskTransition: {
type: String,
default: 'vux-fade'
},
maskZIndex: [Number, String],
dialogTransition: {
type: String,
default: 'vux-dialog'
},
content: String,
closeOnConfirm: {
type: Boolean,
default: true
},
position: {
type: String,
default: 'top'
}
},
created () {
this.showValue = this.show
if (this.value) {
this.showValue = this.value
}
},
filters: {
formatMsToS (time) {
return NP.divide(time, 1000) + 's'
}
},
watch: {
value (val) {
console.log(val)
this.showValue = val
},
showValue (val) {
this.$emit('input', val)
if (val) {
this.$emit('on-show')
}
}
},
data () {
return {
showValue: false,
interval: {
enabled: false,
mode: 'cancel',
timer: '',
intervalTime: winPrizeTipTime
}
}
},
methods: {
intervalCloseConfirm () {
this.interval.intervalTime = winPrizeTipTime
clearInterval(this.interval.timer)
this.interval.timer = setInterval(() => {
this.interval.intervalTime -= 1000
if (this.interval.intervalTime <= 0) {
clearInterval(this.interval.timer)
this.interval.enabled = false
if (this.interval.mode === 'cancel') {
this._onCancel()
} else {
this._onConfirm()
}
}
}, 1000)
},
_onConfirm (ev) {
if (!this.showValue) {
return
}
if (this.closeOnConfirm) {
this.showValue = false
}
this.$emit('on-confirm', ev)
},
_onCancel () {
if (!this.showValue) {
return
}
this.showValue = false
this.$emit('on-cancel')
}
}
}



// WEBPACK FOOTER //
// ./src/components/Confirm/Confirm.vue